import { createAction, props } from '@ngrx/store';
import { HttpException } from '@uzurv/core';
import { FeatureFlag } from 'projects/uzurv/src/services/feature-flag/feature-flag.interfaces';

export const InitializeFeatureFlags = createAction('[Feature Flag] Initialize feature flags');
export const InitializeFeatureFlagsSuccess = createAction('[Feature Flag] Initialize feature flags success');
export const InitializeFeatureFlagsFail = createAction('[Feature Flag] Initialize feature flags fail', props<{ error: HttpException }>());

export const FetchFeatureFlagsSuccess = createAction(
  '[Feature Flag] Fetch feature flags success',
  props<{ flags: Record<string, FeatureFlag> }>()
);
export const FetchFeatureFlagsFail = createAction('[Feature Flag] Fetch feature flags fail', props<{ error: HttpException }>());

export const RehydrateFeatureFlags = createAction('[Feature Flag] Rehydrate feature flags');
export const RehydrateFeatureFlagsSuccess = createAction(
  '[Feature Flag] Rehydrate feature flags success',
  props<{ flags: Record<string, FeatureFlag> }>()
);

export const StartPollingFeatureFlags = createAction('[Feature Flag] Start polling feature flags');
export const StopPollingFeatureFlags = createAction('[Feature Flag] Stop polling feature flags');

export const TrackExposureEvent = createAction('[Feature Flag] Track Exposure Event', props<{ flagCode: string }>());
